var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"待收货","name":"list"}},[_c('List',{ref:"list"})],1),_c('el-tab-pane',{attrs:{"label":"待反馈","name":"history"}},[_c('History',{ref:"history"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }